import { render, staticRenderFns } from "./GoodPup.vue?vue&type=template&id=2ab870b4&scoped=true"
import script from "./GoodPup.vue?vue&type=script&lang=js"
export * from "./GoodPup.vue?vue&type=script&lang=js"
import style0 from "./GoodPup.vue?vue&type=style&index=0&id=2ab870b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab870b4",
  null
  
)

export default component.exports